import { hideBasketAlertBox } from ".";
import { hideElement, isDefined, isNullOrEmpty, showElement } from "../../../utils";
import { constants } from "../common";
import { hideBasketNotificationBar } from "./hideBasketNotificationBar";

const { basketAlert, basketUpgrade, checkoutButton, standardMsg, expiryText, closeButton } = constants.selectors;
const { basketAlertTimeout } = constants.defaults;

export let alertBoxTimeout: number | undefined;

let previousStyle: string | undefined;

export function showBasketAlertBox({
  message,
  delay,
  style,
  upgradeUrl,
  checkoutUrl,
  hideCheckoutButton,
  hideTimer,
  onBeforeCheckout,
  onClosed,
}: BasketAlertBoxOptions) {
  const timeRemainingElement = document.querySelector(".checkout-basket-bar .remaining-time");
  if (timeRemainingElement) {
    timeRemainingElement.classList.add("remaining-time--low");
  }

  const basketAlertElement = document.querySelector(basketAlert);
  if (!basketAlertElement) {
    console.warn("Basket alerts not supported on current page.");
    return;
  }

  hideBasketNotificationBar();

  const alertMessageElement = basketAlertElement.querySelector(standardMsg);
  const checkoutButtonElement = basketAlertElement.querySelector<HTMLAnchorElement>(checkoutButton);
  const closeButtonElement = basketAlertElement.querySelector<HTMLButtonElement>(closeButton);
  const upgradeNoticeElement = basketAlertElement.querySelector(basketUpgrade);

  //upgrade message element
  if (!isNullOrEmpty(style)) {
    if (!isNullOrEmpty(previousStyle)) {
      basketAlertElement.classList.remove(previousStyle);
    }
    basketAlertElement.classList.add(style);
    previousStyle = style;
  } else if (!isNullOrEmpty(previousStyle)) {
    basketAlertElement.classList.remove(previousStyle);
    previousStyle = undefined;
  }

  if (!isNullOrEmpty(upgradeUrl)) {
    showElement(upgradeNoticeElement, "block");
    const viewOptionsLink = upgradeNoticeElement.querySelector<HTMLAnchorElement>("a.button");
    viewOptionsLink.href = upgradeUrl;
  }

  if (!isNullOrEmpty(message) && alertMessageElement) {
    alertMessageElement.innerHTML = message;
  }

  if (hideTimer === true) {
    hideElement(basketAlertElement.querySelector(expiryText));
  } else {
    showElement(basketAlertElement.querySelector(expiryText));
  }

  if (checkoutButtonElement !== null) {
    if (!isNullOrEmpty(checkoutUrl)) {
      checkoutButtonElement.href = checkoutUrl;
    }

    if (hideCheckoutButton === true) {
      hideElement(checkoutButtonElement);
    } else {
      showElement(checkoutButtonElement);
      checkoutButtonElement.addEventListener("click", (e) => {
        e.preventDefault();
        if (!!onBeforeCheckout) {
          onBeforeCheckout();
        }
        window.location.href = checkoutButtonElement.href;
      });
    }
  }

  if (isDefined(onClosed) && closeButtonElement) {
    closeButtonElement.addEventListener("click", () => {
      onClosed();
      hideElement(basketAlertElement);
    });
  }
  //show alert box
  if (window.localStorage.getItem(constants.defaults.basketAlertLocalStorageKey) !== "true") {
    showElement(basketAlertElement);
  }

  //hide alert box after 5 seconds unless told otherwise by the options
  let timeout: number | undefined = basketAlertTimeout;

  if (delay === "none") {
    timeout = null;
  } else if (delay >= 0) {
    timeout = delay;
  }

  if (!!timeout && timeout >= 0) {
    if (alertBoxTimeout && alertBoxTimeout !== timeout) {
      clearTimeout(alertBoxTimeout);
    }
    alertBoxTimeout = setTimeout(
      () => {
        hideBasketAlertBox();
      },
      timeout,
      null
    );
  }
}

export type BasketAlertBoxOptions = {
  message?: string;
  delay?: number | "none";
  style?: string;
  total?: string;
  upgradeUrl?: string;
  checkoutUrl?: string;
  hideTimer?: boolean;
  hideCheckoutButton?: boolean;
  onBeforeCheckout?: () => void;
  onClosed?: () => void;
};
